export enum UploadCategoryEnum {
  APPLICATION_LOGO = 'app-logo',
  LEGEND = 'legend',
  IMAGE = 'image',
  SSO_IMAGE = 'sso-image',
  LAYER_ATTACHED_FILE = 'layer-attached-file',
  UNRESTRICTED = 'unrestricted',
  HEADER_LOGO = 'header-logo',
  DRAWING_STYLE = 'drawing-style',
  DRAWING_STYLE_IMAGE = 'drawing-style-image',
}
